"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileConnectorDevInitializer = exports.MobileConnectorInitializer = exports.MobileConnectorDevInitializationError = exports.MobileConnectorInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const mobileConnector_1 = require("./mobileConnector");
const mobileConnectorV2_1 = require("./mobileConnectorV2");
const mock_1 = require("./mock");
const MOBILE_COMMUNICATOR_ERROR = 'Mobile communicator initialization error';
class MobileConnectorInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(MOBILE_COMMUNICATOR_ERROR, message);
    }
}
exports.MobileConnectorInitializationError = MobileConnectorInitializationError;
class MobileConnectorDevInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(MOBILE_COMMUNICATOR_ERROR, message);
    }
}
exports.MobileConnectorDevInitializationError = MobileConnectorDevInitializationError;
class MobileConnectorInitializer extends web_ui_framework_1.Initializer {
    constructor() {
        super(...arguments);
        this.launch = async () => {
            try {
                let deviceConnector;
                if ((0, web_ui_framework_1.isAndroidWebView)()) {
                    deviceConnector = new web_ui_framework_1.AndroidDeviceConnector();
                }
                else if ((0, web_ui_framework_1.isIosWebView)()) {
                    deviceConnector = new web_ui_framework_1.IOSDeviceConnector();
                }
                else {
                    throw new MobileConnectorInitializationError('Mobile communicator initialization error need to run in Android or iOS webview');
                }
                if ((0, web_ui_framework_1.isProtocol2)()) {
                    return new mobileConnectorV2_1.MobileConnectorV2(deviceConnector, new web_ui_framework_1.MobileHandlerV2(deviceConnector));
                }
                return new mobileConnector_1.MobileConnector(deviceConnector, new web_ui_framework_1.MobileHandler(deviceConnector));
            }
            catch (e) {
                throw new MobileConnectorInitializationError(e);
            }
        };
    }
}
exports.MobileConnectorInitializer = MobileConnectorInitializer;
class MobileConnectorDevInitializer extends web_ui_framework_1.Initializer {
    constructor(session) {
        super([session]);
        this.launch = async () => {
            try {
                const deviceConnector = (0, mock_1.getDeviceConnectorMock)(this.session.getInitialized());
                const mobileConnector = new mobileConnector_1.MobileConnector(deviceConnector, new web_ui_framework_1.MobileHandler(deviceConnector));
                return mobileConnector;
            }
            catch (e) {
                throw new MobileConnectorDevInitializationError(e);
            }
        };
        this.session = session;
    }
}
exports.MobileConnectorDevInitializer = MobileConnectorDevInitializer;
//# sourceMappingURL=mobileConnector.initializer.js.map